import React from "react";

export const CharacterCount = ({ characterCount, maxLength }) => {
    if (characterCount === undefined || characterCount === null) return null;

    return (
        <div
            style={{
                float: "right",
                marginTop: "-20px",
                marginRight: "15px",
                fontSize: "10px",
                color: "#999999",
            }}>
            {maxLength ? `${characterCount}/${maxLength}` : characterCount}
        </div>
    );
};
